import { Link } from "react-router-dom";
import { BookOpen, ArrowRight } from "lucide-react";
import { getTerm } from "@/data/glossary";

const FEATURED_SLUGS = [
  "individual-education-plan-iep",
  "disability-tax-credit-dtc",
  "ontario-autism-program-oap",
  "applied-behaviour-analysis-aba",
  "occupational-therapy-ot",
  "autism-assessment",
  "child-disability-benefit-cdb",
  "stimming",
];

// Compact glossary internal-links block. `variant` controls background context.
export function FeaturedGlossary({ className = "" }) {
  const terms = FEATURED_SLUGS.map(getTerm).filter(Boolean);
  if (terms.length === 0) return null;

  return (
    <section className={`kid-card p-6 sm:p-7 ${className}`} data-testid="featured-glossary">
      <div className="flex flex-wrap items-start gap-3 mb-5">
        <div className="w-10 h-10 rounded-2xl bg-kid-teal/10 text-kid-teal grid place-items-center shrink-0"><BookOpen size={20} /></div>
        <div className="flex-1 min-w-[200px]">
          <h3 className="font-display text-xl font-extrabold text-kid-navy">Understand the terms</h3>
          <p className="text-sm text-kid-muted">Plain-language definitions of the words you'll meet in reports, school plans, and funding applications.</p>
        </div>
        <Link to="/terms" className="text-sm font-semibold text-kid-tealcta hover:underline inline-flex items-center gap-1 shrink-0" data-testid="featured-glossary-browse-all">
          Browse all 239 terms <ArrowRight size={15} />
        </Link>
      </div>
      <div className="flex flex-wrap gap-2">
        {terms.map((t) => (
          <Link key={t.slug} to={`/terms/${t.slug}`} data-testid={`featured-term-${t.slug}`}
            className="text-sm font-semibold rounded-full px-4 py-2 border border-kid-line text-kid-navy hover:border-kid-teal hover:text-kid-teal transition-colors">
            {t.title}{t.acronym ? ` (${t.acronym})` : ""}
          </Link>
        ))}
      </div>
    </section>
  );
}
